// extracted by mini-css-extract-plugin
export var content = "text-image-hs-module--content--1c36b";
export var headline = "text-image-hs-module--headline--74b1b";
export var image = "text-image-hs-module--image--13623";
export var left = "text-image-hs-module--left--7ce8a";
export var right = "text-image-hs-module--right--e7999";
export var textImage = "text-image-hs-module--text-image--9335d";
export var youtube = "text-image-hs-module--youtube--e7553";